import warning from '../_util/warning';

var Icon = function Icon() {
  warning(false, 'Icon', 'Empty Icon');
  return null;
};

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@4.1.3@antd/es/icon/index.js
// module id = 2501
// module chunks = 0